import { Phone, PhoneIncoming, PhoneOutgoing } from 'lucide-react'
import { formatDistanceToNow } from 'date-fns'
import clsx from 'clsx'

function RecentCalls({ calls }) {
  const getStatusBadge = (status) => {
    const baseClasses = 'status-badge'
    
    switch (status) {
      case 'completed':
        return `${baseClasses} status-active`
      case 'failed':
      case 'busy':
      case 'no-answer':
        return `${baseClasses} status-inactive`
      case 'in-progress':
      case 'ringing':
        return `${baseClasses} status-pending`
      default:
        return `${baseClasses} bg-primary-100 text-primary-800`
    }
  }

  const getDirectionIcon = (direction) => {
    return direction === 'inbound' ? PhoneIncoming : PhoneOutgoing
  }

  if (!calls || calls.length === 0) {
    return (
      <div className="text-center py-8">
        <Phone className="mx-auto h-12 w-12 text-primary-400" />
        <h3 className="mt-2 text-sm font-medium text-primary-900">No calls</h3>
        <p className="mt-1 text-sm text-primary-500">
          No recent calls to display.
        </p>
      </div>
    )
  }

  return (
    <div className="flow-root">
      <ul role="list" className="-my-5 divide-y divide-primary-200">
        {calls.map((call) => {
          const DirectionIcon = getDirectionIcon(call.direction)
          
          return (
            <li key={call._id} className="py-4">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <div className={clsx(
                    'h-8 w-8 rounded-full flex items-center justify-center',
                    call.direction === 'inbound' ? 'bg-green-100' : 'bg-blue-100'
                  )}>
                    <DirectionIcon className={clsx(
                      'h-4 w-4',
                      call.direction === 'inbound' ? 'text-green-600' : 'text-blue-600'
                    )} />
                  </div>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-primary-900 truncate">
                    {call.direction === 'inbound' ? call.from : call.to}
                  </p>
                  <p className="text-sm text-primary-500 truncate">
                    {call.phoneNumber} • {call.duration ? `${call.duration}s` : 'No duration'}
                  </p>
                </div>
                <div className="flex flex-col items-end space-y-1">
                  <span className={getStatusBadge(call.status)}>
                    {call.status}
                  </span>
                  <p className="text-xs text-primary-500">
                    {formatDistanceToNow(new Date(call.createdAt), { addSuffix: true })}
                  </p>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default RecentCalls